import React, { Component } from 'react';

//views
import CariAppFormPgSubmitted from "../../../cari_app_form_view/simple/CariAppFormPgSubmitted";
import CariAppFormPgLayoutRouting from "./CariAppFormPgLayoutRouting";
import CariMainPgLoggedInHeaderView from "../../../cari_template_view/CariMainPgLoggedInHeaderView";


//generic functions
import {
    isEmpty
} from "../../../../../../functions/generic_functions";

//router
import { 
    Route,
    Switch,
    Redirect
} from 'react-router-dom';

//import static routes
import { 
    cari_home_pg_url,
    cari_app_form_url,
    cari_app_form_pg_submitted_url,
} from "../../../../../../router/static_routes";

//redux
import { connect } from "react-redux";

//redux mapper
const mapStateToProps = state => {
    return {
        activePositionData: state.cariReducer.activePositionData
    };
};

class CariAppFormLayoutRouting extends Component {

    constructor(Props) {
        super(Props);

        //set active position
        this.getActivePositionDataFromStore = this.getActivePositionDataFromStore.bind(this);

        //check application data
        this.checkIfApplicationComplete = this.checkIfApplicationComplete.bind(this);
    }

    componentDidMount() {
        if (!isEmpty(this.props.activePositionData)) {
            document.title = this.getActivePositionDataFromStore().position_title + " application";
        }
    }

    //get active position data from redux store
    getActivePositionDataFromStore() {
        var copyPositionData = this.props.activePositionData;

        if (!isEmpty(copyPositionData)) {
            return copyPositionData;
        }
        else {
            return {"position_id": null, "position_title": "Position Title"}
        }
    }
    
    //check if the application data application status is set toc omplete
    checkIfApplicationComplete() {
        if (!isEmpty(this.props.activeApplicationData)
            && !isEmpty(this.props.activeApplicationData.application_id)
            && !isEmpty(this.props.activeApplicationData.application_status)
            && this.props.activeApplicationData.application_status.toLowerCase() === "complete") {
            return true;
        }
        else {
            return false;
        }
    }

    render() {
        return (
            <div>
                <div className="p-grid">
                    <div className="p-col-12 layout_header_view">
                        <CariMainPgLoggedInHeaderView
                            siteTitle={this.props.siteTitle}
                        /> 
                    </div>
                </div> 
                <div className="p-grid">
                    <div className="p-col-12 layout_left_right_padding">
                        <br/><br/>
                        <label className="cari_title">
                            {this.getActivePositionDataFromStore().position_title}
                        </label>
                        
                        <Switch>
                            {/* TODO need call back on application complete to set status */}
                            {/* {this.checkIfApplicationComplete() ? */}
                                <Route
                                    exact
                                    path={cari_app_form_pg_submitted_url}
                                    component={CariAppFormPgSubmitted}
                                />
                            {/* : null} */}
                            
                            <Route
                                exact
                                path={cari_app_form_url + "/:pageNum([1-4]{1,1})"}
                                component={CariAppFormPgLayoutRouting}
                            />

                            <Redirect
                                from='*'
                                to={cari_home_pg_url}
                            />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps)(CariAppFormLayoutRouting);